let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kfXhT"), load("2Lfdl"), load("h2MrD"), load("bYT2S"), load("3ZBUM")]).then(() => parcelRequire('kWbha'));